import {
  FETCH_COMPANY_SUCCESS,
  SHOW_COMPANY_MESSAGE,
  SHOW_COMPANY_LOADER,
  SHOW_BTN_UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  ON_ADD_USER,
  ON_USER_CLOSE,
  SHOW_COMPANY_USERS_LOADER,
  FETCH_COMPANY_USERS_SUCCESS,
  HIDE_COMPANY_MESSAGE,
  ON_CREATE_COMPANY_USER_SUCCESS,
  ON_UPDATE_COMPANY_USER_SUCCESS
} from 'constants/ActionTypes';

const INIT_STATE = {
  company: {},
  apiCompanyLoaded: false,
  alertMessage: '',
  showMessage: false,
  isErrorMessage: false,
  btnCompanyUpdate: false,
  addUserState: false,
  apiUsersLoaded: false, 
  userList: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_COMPANY_SUCCESS: {
      return {
        ...state,
        company: action.payload,
        apiCompanyLoaded: true
      }
    }
    case SHOW_COMPANY_LOADER: {
      return {
        ...status,
        apiCompanyLoaded: false
      }
    }
    case SHOW_COMPANY_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        btnCompanyUpdate: false,
        apiCompanyLoaded: true,
        apiUsersLoaded: true
      }
    }
    case SHOW_BTN_UPDATE_COMPANY: {
      return {
        ...state,
        btnCompanyUpdate: true
      }
    }
    case UPDATE_COMPANY_SUCCESS: {
      return {
        ...state,
        company: action.payload,
        btnCompanyUpdate: false
      }
    }
    case ON_ADD_USER: {
      return { 
        ...state, 
        addUserState: true 
      };
    }
    case ON_USER_CLOSE: {
      return { 
        ...state, 
        addUserState: false 
      };
    }
    case HIDE_COMPANY_MESSAGE: {
      return { 
        ...state, 
        showMessage: false 
      };
    }
    case SHOW_COMPANY_USERS_LOADER: {
      return { 
        ...state, 
        apiUsersLoaded: false 
      };
    }
    case FETCH_COMPANY_USERS_SUCCESS: {
      return { 
        ...state, 
        userList: action.payload,
        apiUsersLoaded: true,
      };
    }
    case ON_UPDATE_COMPANY_USER_SUCCESS: {
      const userPayload = action.payload
      const userList = state.userList.map(user => {
        if (user.id === userPayload.id) {
          return userPayload
        } else {
          return user
        }
      })
      return { 
        ...state, 
        userList,
        showMessage: true,
        isErrorMessage: false,
        apiCompanyLoaded: true,
        apiUsersLoaded: true,
        alertMessage: 'user.updateProfileSuccess',
       };
    }
    case ON_CREATE_COMPANY_USER_SUCCESS: {
      const userList = state.userList
      userList.push(action.payload)
      return {
        ...state,
        userList,
        showMessage: true,
        isErrorMessage: false,
        apiCompanyLoaded: true,
        apiUsersLoaded: true,
        alertMessage: 'company.userSuccessfullyCreated',
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/Company.js